import initialState from '../reducers/initialState';
import {ROUTER_LOCATION_CHANGE} from '../constants/actionTypes';

const BETA_PARAM_NAME = 'beta';

export default function appConfigReducer(state = initialState.appConfig, action) {
  switch(action.type) {
    case ROUTER_LOCATION_CHANGE: {
      const allowOrdering = (BETA_PARAM_NAME in action.payload.query);
      return { ...state, allowOrdering};
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appConfigReducer.js